import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "item", "empty"]

  filter() {
    const query = this.normalize(this.inputTarget.value)
    let visible = 0

    this.itemTargets.forEach(item => {
      const match = query === "" || this.normalize(item.textContent).includes(query)
      item.classList.toggle("hidden", !match)
      if (match) visible++
    })

    if (this.hasEmptyTarget) this.emptyTarget.classList.toggle("hidden", visible > 0)
  }

  normalize(text) {
    return text
      .toLocaleLowerCase("pl")
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replaceAll("ł", "l")
  }
}
